<template>
  <div class="overlay">
    <Loader v-if="wait" />
    <transition name="fade">
      <div class="popin-error" v-if="!wait">
        <img src="@/assets/images/ic_warning.svg" />
        <h3>Serveurs surchargés</h3>
        <p>
          Désolé, nous avons actuellement trop de visiteurs sur la plateforme.
        </p>
        <p>
          Nous travaillons sur la remise en fonction de nos serveurs !
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/Common/Loader";
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "PopinError",
  components: {
    Loader
  },
  data() {
    return {
      wait: true
    };
  },
  computed: {
    ...mapGetters({
      getErrorOnStorage: "getErrorOnStorage"
    })
  },
  methods: {
    ...mapMutations({
      updateBodyNoScroll: "updateBodyNoScroll"
    })
  },
  mounted() {
    this.updateBodyNoScroll(true);
    // if (this.getErrorOnStorage !== "true") {
    setTimeout(() => {
      this.wait = false;
    }, 5000);
    // } else {
    //   this.wait = false;
    // }
  },
  beforeDestroy() {
    this.updateBodyNoScroll(false);
  }
};
</script>

<style lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 30;
}
.popin-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  background: white;
  box-shadow: get($shadows, "light");
  padding: 6rem 3rem;
  text-align: center;
  @media #{$md-and-up} {
    width: 50%;
  }
  > h3 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 3rem;
  }
  > img {
    width: 4rem;
    margin-bottom: 2rem;
  }
}
</style>
